/*
 * @Author: ts.r
 * @Date: 2020-10-26 10:58:56
 * @LastEditTime: 2021-02-07 12:26:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cmine-pro-fe/src/components/enroll/enrollMixin.js
 */
import CountBtn from '@/components/enroll/CountBtn.vue'
export default {
  data() {
    return {
      // 图形验证码错误
      code_error: '',
      // 手机号错误
      tel_error: '',
      // 密码错误
      password_error: '',
      // 重复密码错误
      repeatPasswordError: '',
      // 姓名错误
      nameError: '',
      // 手机验证码错误
      telCodeError: '',
      // 姓名
      name: '',
      // 手机号
      tel: '',
      // 图形验证码
      code: '',
      // 手机验证码
      telCode: '',
      // 密码
      psw: '',
      // 重复输入密码
      repeatPsw: '',
      // 明文
      show: false
    }
  },
  components: { CountBtn },
  props: {
    clean: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clearEnroll() {
      this.tel = ''
      this.code = ''
      this.psw = ''
      this.repeatPsw = ''
      this.checked = false
      this.code_error = ''
      this.password_error = ''
      this.telCodeError = ''
      this.tel_error = ''
      this.show = false
    },
    clearLogin() {
      this.tel = ''
      this.code = ''
      this.psw = ''
      this.repeatPsw = ''
      this.remember_me = false
      this.code_error = ''
      this.password_error = ''
      this.telCodeError = ''
      this.tel_error = ''
      this.active_key = 1
      this.show = false
    },
    resultHandler(msg) {
      if (msg) {
        this.tel_error = msg
      }
    },
    showError(d) {
      this.password_error = d.error === '账号或密码错误，请重试。' ? '账号或密码错误' : ''
      this.tel_error = d.error === '请使用教师账号登录' ? d.error : ''
      this.code_error = d.error.includes('验证码') ? d.error : ''
    },
    removeFocus(e) {
      let id = e.target.id
      let targetParent = e.target.parentElement
      if (!targetParent) return
      let classes = targetParent.classList
      classes.remove('nor-focus')
      // 提示错误对象
      const testErrorObj = {
        // 电话号码
        tell1: () => (this.tel_error = !/^1\d{10}$/.test(this.tel) ? '请输入11位手机号码' : ''),
        // 密码
        psw: () =>
          (this.password_error = !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{8,20}$/.test(this.psw)
            ? '请输入8~20位数字和字母组合'
            : ''),
        // 重复密码
        repeatPsw: () =>
          (this.repeatPasswordError = !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{8,20}$/.test(
            this.repeatPsw
          )
            ? '请输入8~20位数字和字母组合'
            : ''),
        // 姓名
        name: () =>
          (this.nameError = !/^[\u4e00-\u9fa5]{2,10}$/.test(this.name)
            ? '请输入中文2-10位中文名字'
            : ''),
        // 图形验证码
        imgCode: () => (this.code_error = !this.code ? '请输入正确的图形验证码' : ''),
        // 手机验证码
        telCode: () => (this.telCodeError = !this.telCode ? '请输入正确的短信验证码' : '')
      }
      testErrorObj[id] && testErrorObj[id]()
    },
    changeEye() {
      this.show = !this.show
    },
    getFocus(e) {
      let targetParent = e.target.parentElement
      targetParent && targetParent.classList.add('nor-focus')
    }
  }
}
